import React, { useState, useEffect } from "react";
import { Button, Flex, Image, Text } from "@chakra-ui/react";

import { GetLocalAuthRole } from "../services/MoblyzeAuth";
import { ReactComponent as LeftArrow } from "../assets/icons/left-arrow.svg";
import { AgencyClientShareAction } from "./Shortlist/AgencyShareActions";

import { Icon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";

import { AgencyEditArchiveJobMenu } from "./AgencyJobActions";
import ClientJobNotificationSettings from "./ClientJobNotificationSettings";
import JobDetails from "./JobDetails";
import { adjustIntercomWidget } from "../helpers/hooks";

export default function JobHeader({
  moblyzeJob,
  isClient,
  isAgency,
  isArchived,
}) {
  const navigate = useNavigate();

  const [showJobDetail, setShowJobDetail] = useState();

  const [role, setRole] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const authRole = await GetLocalAuthRole();
      setRole(authRole);
    };
    fetchData();
  }, []);

  const renderActions = () => {
    if (isClient) {
      return (
        <Flex alignItems="center" direction="row" gap="16px" h="40px">
          <ClientJobNotificationSettings moblyzeJob={moblyzeJob} />
          <Button
            colorScheme="white"
            variant="outline"
            borderColor="gray.600"
            _hover={{ borderColor: "gray.300" }}
          >
            Recruiter Details
          </Button>
          <Button
            colorScheme="white"
            variant="outline"
            borderColor="gray.600"
            _hover={{ borderColor: "gray.300" }}
            onClick={() => setShowJobDetail(true)}
          >
            View Job Details
          </Button>
        </Flex>
      );
    } else if (isAgency) {
      return (
        <Flex alignItems="center" direction="row" gap="16px" h="40px">
          <ClientJobNotificationSettings moblyzeJob={moblyzeJob} />
          <Button
            colorScheme="white"
            variant="outline"
            borderColor="gray.600"
            _hover={{ borderColor: "gray.300" }}
            onClick={() => setShowJobDetail(true)}
          >
            View details
          </Button>
          <AgencyClientShareAction moblyzeJob={moblyzeJob} />
          {!isArchived && <AgencyEditArchiveJobMenu moblyzeJob={moblyzeJob} />}
        </Flex>
      );
    }

    return null;
  };

  return (
    <Flex flexDir="column" gap="24px">
      <Flex gap={4} alignItems="center" flexWrap="wrap">
        <Text
          onClick={() => {
            // if we can naviate to the previous page, do so
            // otherwise, navigate to the home page
            if (window.history.length > 1) {
              navigate(-1);
            } else {
              navigate("/");
            }
            adjustIntercomWidget();
          }}
          fontSize="md"
          lineHeight="6"
          fontWeight="normal"
          cursor="pointer"
        >
          <Icon fontSize="10px" as={LeftArrow} /> Back
        </Text>
        <Image
          h={45}
          borderRadius={6}
          src={moblyzeJob?.coverImageUrl}
          objectFit="cover"
        />
        <Flex alignItems="center">
          <Text fontSize="xl" fontWeight="bold" lineHeight="6">
            {moblyzeJob?.category}
          </Text>
        </Flex>
        <Flex ml="auto" alignItems="center">
          {renderActions()}
        </Flex>
        <JobDetails
          isOpen={showJobDetail}
          onClose={() => setShowJobDetail(false)}
          moblyzeJob={moblyzeJob}
          isClient={role === "Client"}
        />
      </Flex>
    </Flex>
  );
}
